import { FetchResourceGroupsQuery, FetchResourceGroupsQueryVariables } from 'app/__generated__/global';
import { ApolloProvider } from 'core/net/ApolloProvider';
import { FETCH_RESOURCE_GROUPS } from './graphql/facility.fetchResourceGroups';

export const fetchResourceGroups = async () => {
  const { data } = await ApolloProvider.global().query<FetchResourceGroupsQuery, FetchResourceGroupsQueryVariables>({
    query: FETCH_RESOURCE_GROUPS,
  });
  return data?.facility?.resourceGroups.map(
    ({
      id,
      name,
      processVariableIds,
      processIds,
      users,
      isPublic,
      noiseEventPolicy,
      enabledOverrideCount,
      disabledOverrideCount,
      reportDefinitionIds,
    }) => ({
      id,
      name,
      processVariableIds,
      processIds,
      userIds: users.flatMap(({ user }) => user?.id ?? []),
      isPublic,
      noiseEventPolicy,
      enabledOverrideCount,
      disabledOverrideCount,
      reportDefinitionIds,
    })
  );
};
